import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as ROUTES from "../constants/routes";
import { updateUser } from "../reducers/userReducer";
import { toggleModal } from "../reducers/modalReducer";
import { setLogout, getRequest, showMessage } from '../config';
import { Menu, Close } from "@mui/icons-material";

const KOALENDAR = "https://koalendar.com/e/meet-with-mark-bernstein";
const Chevron = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>;

export default function NewHeader() {

    const dispatch = useDispatch();
    const location = useLocation();
    const isPartnerChecklist = location.pathname.startsWith('/partnerChecklist/');
    const isCompleteInvestmentPage = location.pathname.startsWith('/completeInvestment');
    const isClimb26LandingPage = location.pathname.includes('climb26') || location.pathname.includes('climb');

    let user = useSelector(state => state.user);
    const [isScrolled, setIsScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [openDD, setOpenDD] = useState('');

    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");

    useEffect(() => {
        if (localStorage.getItem("token")) { getUser(); checkLogin(); }
    }, []);

    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // lock body scroll when the mobile drawer is open
    useEffect(() => {
        document.body.style.overflow = mobileOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [mobileOpen]);

    const getUser = async () => {
        let response = await getRequest(`/user`);
        if (response['code'] == 200 && response['body']) {
            user = response['body']['user'];
            dispatch(updateUser(user));
        }
    };

    const checkLogin = async () => await getRequest("/user/checkLogin");

    const handleLoginRegister = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        if (mobileRegex.test(userAgent)) return showMessage("You can Login/Register on Laptop");
    };

    const handleDashboardClick = (e) => {
        if (isCompleteInvestmentPage) { e.preventDefault(); dispatch(toggleModal({ open: 'setPasswordPopup' })); }
        setMobileOpen(false);
    };

    const redirectDashbaord = () => {
        if (!user?.['_id']) return;
        const urlParams = new URLSearchParams(window.location.search);
        const pathname = window.location.pathname;
        let companyId = urlParams.get('companyId');
        if (companyId && companyId.includes(';')) companyId = companyId.split(';')[0];
        if (pathname.includes('createChecklist') && companyId) return `/company/${companyId}`;
        if (pathname.includes('researchAid/')) {
            const researchAidCompanyId = pathname.split('researchAid/')[1]?.split('?')[0];
            if (researchAidCompanyId) return `/company/${researchAidCompanyId}`;
        }
        if (user['role'] == 'Guest') return ROUTES.REGISTER;
        else if (user['role'] == 'Advisor') return ROUTES.ADVISOR;
        else if (user['role'] == 'Investor') return ROUTES.INVESTOR;
        else return ROUTES.DASHBOARD;
    };

    const isActive = (path) => location.pathname === path;
    const closeAll = () => { setMobileOpen(false); setOpenDD(''); };

    // Routes redesigned to the new landing system opt into the transparent-over-hero
    // navbar. Every other landing page keeps a solid bar + spacer so the fixed
    // header never overlaps content until that page is redesigned too.
    const REDESIGNED_ROUTES = [ROUTES.HOME, ROUTES.HOME_PAGE, ROUTES.LANDING_PAGE, ROUTES.LANDING_PAGE_FRACTIONAL, ROUTES.LANDING_PAGE_ANGEL_NETWORKS, ROUTES.LANDING_PAGE_ACCOUNTANT, ROUTES.LANDING_PAGE_PISCES];
    const isRedesigned = REDESIGNED_ROUTES.includes(location.pathname);

    // ---- minimal in-flow bars for special contexts ----
    if (isPartnerChecklist) {
        return (
            <header className="nav2 is-scrolled" style={{ position: 'relative' }}>
                <div className="nav2-inner">
                    <Link className="nav2-logo" to={ROUTES.HOME}><img src={require('../../images/logodiligentsia.svg')} alt="Diligentsia" /></Link>
                </div>
            </header>
        );
    }
    if (isClimb26LandingPage) {
        return (
            <header className="nav2" style={{ position: 'relative', background: '#151313', boxShadow: 'none' }}>
                <div className="nav2-inner">
                    <Link className="nav2-logo" to={ROUTES.HOME}><img src={require('../../images/logo_white.png')} alt="Diligentsia" /></Link>
                </div>
            </header>
        );
    }

    return (
        <>
        <header className={`nav2 ${(isScrolled || mobileOpen || !isRedesigned) ? 'is-scrolled' : ''}`}>
            <div className="nav2-inner">
                <Link className="nav2-logo" to={ROUTES.HOME} onClick={closeAll}>
                    <img src={require('../../images/logodiligentsia.svg')} alt="Diligentsia" />
                </Link>

                {!isClimb26LandingPage && <>
                    {/* desktop links */}
                    <div className="nav2-links">
                        <Link className={`nav2-link ${isActive(ROUTES.LANDING_PAGE) ? 'is-active' : ''}`} to={ROUTES.LANDING_PAGE}>Companies</Link>
                        {/* <Link className={`nav2-link ${isActive(ROUTES.LANDING_PAGE_FRACTIONAL) ? 'is-active' : ''}`} to={ROUTES.LANDING_PAGE_FRACTIONAL}>Fractional</Link> */}

                        <div className="nav2-dd" onMouseEnter={() => setOpenDD('advisors')} onMouseLeave={() => setOpenDD('')}>
                            <button className="nav2-link">Advisors <Chevron /></button>
                            {openDD === 'advisors' &&
                                <div className="nav2-dd-menu">
                                    <Link className={isActive(ROUTES.LANDING_PAGE_FRACTIONAL) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_FRACTIONAL}>Fractional CFOs</Link>
                                    <Link className={isActive(ROUTES.LANDING_PAGE_ACCOUNTANT) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_ACCOUNTANT}>Accountants</Link>
                                    <Link className={isActive(ROUTES.LANDING_PAGE_PISCES) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_PISCES}>PISCES</Link>
                                </div>}
                        </div>

                        <div className="nav2-dd" onMouseEnter={() => setOpenDD('investor')} onMouseLeave={() => setOpenDD('')}>
                            <button className="nav2-link">Investor <Chevron /></button>
                            {openDD === 'investor' &&
                                <div className="nav2-dd-menu">
                                    <Link className={isActive(ROUTES.LANDING_PAGE_VCS) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_VCS}>Venture Capital</Link>
                                    <Link className={isActive(ROUTES.LANDING_PAGE_PES) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_PES}>Private Equity</Link>
                                    <Link className={isActive(ROUTES.LANDING_PAGE_ANGEL_NETWORKS) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_ANGEL_NETWORKS}>Angel Networks</Link>
                                    {/* <Link className={isActive(ROUTES.LANDING_PAGE_ACCELERATOR) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_ACCELERATOR}>Accelerators &amp; Venture Studios</Link> */}
                                    {/* <Link className={isActive(ROUTES.LANDING_PAGE_ANGELS) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_ANGELS}>Angel Investors</Link> */}
                                </div>}
                        </div>

                        <Link className={`nav2-link ${isActive(ROUTES.PRICING_PLAN) ? 'is-active' : ''}`} to={ROUTES.PRICING_PLAN}>Pricing</Link>
                        <Link className={`nav2-link ${isActive(ROUTES.ABOUT_US) ? 'is-active' : ''}`} to={ROUTES.ABOUT_US}>About Us</Link>
                        <Link className={`nav2-link ${isActive(ROUTES.PARTNER_PROGRAM) ? 'is-active' : ''}`} to={ROUTES.PARTNER_PROGRAM}>Partners</Link>
                        {/* <Link className={`nav2-link ${isActive(ROUTES.COMMUNITY) ? 'is-active' : ''}`} to={ROUTES.COMMUNITY}>Community</Link> */}
                        <Link className={`nav2-link ${isActive(ROUTES.BLOGS) ? 'is-active' : ''}`} to={ROUTES.BLOGS}>Resources</Link>
                    </div>

                    {/* desktop CTAs */}
                    <div className="nav2-cta-group">
                        <a className="nav2-btn nav2-btn--primary" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
                        {loggedIn
                            ? user['type'] == 'External'
                                ? <button className="nav2-btn nav2-btn--outline" onClick={() => setLogout()}>Logout</button>
                                : <>
                                    <Link className="nav2-btn nav2-btn--ghost" onClick={handleDashboardClick} to={isCompleteInvestmentPage ? '#' : redirectDashbaord()} style={user['role'] == 'Guest' ? { pointerEvents: 'none', opacity: .5 } : {}}>Dashboard</Link>
                                    <button className="nav2-btn nav2-btn--outline" onClick={() => { (user['role'] != 'Guest') && setLogout(); }}>Logout</button>
                                </>
                            : <>
                                <Link className="nav2-btn nav2-btn--ghost" to={ROUTES.LOGIN} onClick={handleLoginRegister}>Login</Link>
                                <Link className="nav2-btn nav2-btn--outline" to={ROUTES.REGISTER} onClick={() => { localStorage.removeItem('registerAs'); handleLoginRegister(); }}>Register</Link>
                            </>
                        }
                    </div>

                    {/* mobile hamburger */}
                    <button className="nav2-hamburger" aria-label="Menu" onClick={() => setMobileOpen(o => !o)}>
                        {mobileOpen ? <Close /> : <Menu />}
                    </button>
                </>}
            </div>

            {/* mobile drawer */}
            {!isClimb26LandingPage && mobileOpen &&
                <div className="nav2-mobile">
                    <Link className={isActive(ROUTES.LANDING_PAGE) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE} onClick={closeAll}>Companies</Link>
                    <Link className={isActive(ROUTES.LANDING_PAGE_FRACTIONAL) ? 'is-active' : ''} to={ROUTES.LANDING_PAGE_FRACTIONAL} onClick={closeAll}>Fractional</Link>
                    <Link to={ROUTES.LANDING_PAGE_ACCOUNTANT} onClick={closeAll}>Accountants</Link>
                    <Link to={ROUTES.LANDING_PAGE_PISCES} onClick={closeAll}>PISCES</Link>
                    <Link to={ROUTES.LANDING_PAGE_VCS} onClick={closeAll}>Venture Capital</Link>
                    <Link to={ROUTES.LANDING_PAGE_PES} onClick={closeAll}>Private Equity</Link>
                    <Link to={ROUTES.LANDING_PAGE_ANGEL_NETWORKS} onClick={closeAll}>Angel Networks</Link>
                    <Link to={ROUTES.LANDING_PAGE_ACCELERATOR} onClick={closeAll}>Accelerators &amp; Venture Studios</Link>
                    {/* <Link to={ROUTES.LANDING_PAGE_ANGELS} onClick={closeAll}>Angel Investors</Link> */}
                    <Link to={ROUTES.PRICING_PLAN} onClick={closeAll}>Pricing</Link>
                    <Link to={ROUTES.ABOUT_US} onClick={closeAll}>About Us</Link>
                    <Link to={ROUTES.PARTNER_PROGRAM} onClick={closeAll}>Partner</Link>
                    <Link to={ROUTES.COMMUNITY} onClick={closeAll}>Community</Link>
                    <Link to={ROUTES.BLOGS} onClick={closeAll}>Resources</Link>
                    <div className="nav2-mobile-cta">
                        <a className="p" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
                        {loggedIn
                            ? <Link className="g" to={isCompleteInvestmentPage ? '#' : redirectDashbaord()} onClick={handleDashboardClick}>Dashboard</Link>
                            : <Link className="g" to={ROUTES.LOGIN} onClick={() => { handleLoginRegister(); closeAll(); }}>Login</Link>}
                    </div>
                </div>}
        </header>
        {/* spacer keeps non-redesigned landing pages clear of the fixed bar */}
        {!isRedesigned && <div style={{ height: 72 }} aria-hidden="true" />}
        </>
    );
}
